<template>
    <div class="box mt-5">
      <div class="row">
        <div class="col-md-12 m-3">
          <h3> 
            Instances <ShowHideEye :showSection="showInstances" @toggle="showInstances = !showInstances"/>
            
            <button 
              class="button" 
              v-if="userRole == 1" 
              style="float: right; margin-right: 35px;"
              @click="handleInstanceFlights('budget')"
            >
              <span>Check Flight Budget</span>
            </button>
            
            <button 
              class="button" 
              v-if="userRole == 1" 
              style="float: right; margin-right: 35px;"
              @click="handleInstanceFlights('times')"
            >
              <span>Check Flight Times</span>
            </button>

            <button 
              class="button" 
              v-if="userRole == 1" 
              style="float: right; margin-right: 35px;"
              @click="$emit('manageTransfers')">
              <span>Manage Transfers</span>
            </button>
          </h3>
        </div>
      </div>
      <div class="row" v-if="showInstances">
        <div class="col-md-12">
          <form class="form" v-on:submit.prevent="addInstance">
            <fieldset>
              <div class="form-wrap">
                <div>
                  <label for="instance_title">Title</label>
                  <input id="instance_title" type="text" v-model="newInstance.instance_title">
                </div>
    
                <div>
                  <label for="departure-date">Departure date</label>
                  <input id="departure-date" type="date" v-model="newInstance.departure_date" required>
                </div>
    
                <div v-if="this.group.tour.tour_type == 'air'">
                  <label for="departure_airport">Departure Airport</label>
                  <v-select
                    index="id"
                    id="departure_airport"
                    label="airport_name"
                    :filterable="false"
                    :options="departure_airports"
                    v-model="newInstance.departure_airport_id"
                    v-debounce:500ms="searchDepartureAirports"
                  >
                    <template slot="option" slot-scope="option">
                      {{ option.iata_code }} - {{ option.airport_name }}
                    </template>
                  </v-select>
                </div>
    
                <div v-else-if="this.group.tour.tour_type == 'coach'">
                  <label for="region">Pickup point</label>
                  <v-select
                    v-model="newInstance.pickup_point_id"
                    label="pickup_point_name"
                    id="pickup_point"
                    :options="pickupPoints"
                    index="id"
                    required
                  />
                </div>
    
                <div>
                  <label for="is-special-instance">Is Special Instance</label>
                  <label class="switch">
                    <input id="is-special-instance" type="checkbox" v-model="newInstance.is_special_instance">
                    <span class="switch__slider"></span>
                  </label>
                </div>
    
                <div class="form-submit-inline">
                  <template v-if="this.getLoadStatus">
                    <button type="submit" class="button" disabled><span>Adding instance...</span></button>
                  </template>
                  <template v-else>
                    <button type="submit" class="button" v-if="userRole == 1"><span>Add instance</span></button>
                  </template>
                </div>
              </div>
            </fieldset>
          </form>
          
          <table class="table" cellspacing="0" cellpadding="0">
            <thead v-if="group.instances.length > 0">
              <tr>
                <th>
                  <label class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" @change="selectAllInstances($event)">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description"></span>
                  </label>
                </th>
                <th v-if="group.tour.tour_type == 'air'">Title</th>
                <th v-if="group.tour.tour_type == 'air'">Departure Airport</th>
                <th v-else-if="group.tour.tour_type == 'coach'">Pickup Region</th>
                <th>Start date</th>
                <th></th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="instance of group.instances" :key="instance.id" :class="{'is-special': instance.is_special_instance}">
                <td>
                  <label class="custom-control custom-checkbox">
                    <input type="checkbox" v-model="selectedInstancesForFlightTimeCheck" :value="instance.id" class="custom-control-input">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description"></span>
                  </label>
                </td>
                <td>
                  {{ instance.instance_title }}
                </td>
                <td v-if="instance.airport && group.tour.tour_type == 'air'">{{ instance.airport.airport_name || '' }}</td>
                <td v-else-if="group.tour.tour_type == 'coach'"><span v-if="instance.pick_up_point">{{ instance.pick_up_point.pickup_point_name }}</span></td>
                <td>{{ instance.departure_date | formatDate}}</td>
                <td class="table-action"><a v-on:click="editInstance(instance.id)" class="icon icon--more">Edit</a></td>
                <!-- <td class="table-action"><a @click="" class="icon icon--more">Transfers</a></td> -->
                <td class="table-action">
                  <template v-if="userRole == 1">
                    <template v-if="instance.booking_count == 0">
                      <a v-on:click="deleteInstance(instance.id, instance.airport.airport_name)" class="icon icon--delete">Delete</a>
                    </template>
                    <template v-else>
                      <a href="javascript:void(0)" v-on:click="showNonDeletionMessage" class="icon icon--delete-disabled">Delete</a>
                    </template>
                  </template>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

    <!-- Flight Time Updated Modal -->
    <div class="modal-lg" v-if="showFlightUpdateModel == true">
      <component
        :is="flightUpdateComponent"
        :start_date="group.start_date"
        :group="group"
        :selectedInstancesForFlightTimeCheck="selectedInstancesForFlightTimeCheck"
      />
      <button type="button" class="icon icon--unlink" v-on:click="showFlightUpdateModel = false">Close</button>
    </div>
    <div class="modal__bg" v-if="showFlightUpdateModel == true"></div>
    <!-- Flight Time Update Modal -->

    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import ShowHideEye from '@/components/ShowHideEye.vue'
import InstanceFlightTimes from '@/components/Tour/Group/InstanceFlightTimes.vue'
import InstanceFlightBudget from '@/components/Tour/Group/InstanceFlightBudget.vue'

export default {
  name: 'Instances',
  props: {
      departure_airports: {
          type: Array,
          required: true
      },
      group: {
        type: Object,
        required: true
      }
  },
  computed: {
    ...mapGetters(['getLoadStatus']),
    userRole() {
      let user_role = localStorage.getItem("user_role");
      if (user_role == 1) {
          this.showInstances = true
      }
      return user_role
    },
    baseUrl() {
      return window.location.origin
    } 
  },
  data() {
      return { 
          loading: false,
          showInstances: false,
          newInstance: {
            currency: 'GBP',
            indirect_flights: 0,
            tour_id: this.group.tour.id,
            tour_group_id: this.group.id,
            departure_date : JSON.parse(JSON.stringify(this.group.start_date)), 
          },
        selectedInstancesForFlightTimeCheck: [],
        showFlightUpdateModel: false,
        flightUpdateComponent:null
      }
  },
  components: {
    ShowHideEye,
    InstanceFlightTimes,
    InstanceFlightBudget
  },
  methods: {
    searchDepartureAirports(search) {
        if(this.loading === false ) {
            this.loading = true
            fetch(this.$api + 'airports/search/' + search, {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': localStorage.getItem('token')
                }
            })
            .then(res => res.json())
            .then(response => {
                this.departure_airports = response.data
                this.loading = false
            })
        }
    },
    addInstance () {
        this.$store.dispatch('setLoadStatus')
        fetch(this.$api + 'tours/instances', {
            method: 'POST',
            body: JSON.stringify(this.newInstance),
            headers:{
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': localStorage.getItem('token')
            }
        })
        .then(res => res.json())
        .then(response => {
            this.errors = response.errors
            if(response.success == true) {
                this.$notify({
                    type: 'success',
                    title: response.message
                });
                this.resetForm()
                this.$emit('getGroup')
            } else if (response.errors) {
                this.$notify({
                    type: 'error',
                    title: response.message
                });
            } else {
                this.$notify({
                    type: 'error',
                    title: response.Error
                });
            }
            this.$store.dispatch('setLoadStatus')
        });
    },
    editInstance (instanceID) {
      this.$router.push({ name: 'tour-instance', params: { id: instanceID }})
    },
    showNonDeletionMessage() {
        this.$swal({
            icon: "error",
            title: "Oops...",
            text: "Sorry, this instance have active bookings.",
        });
    },
    deleteInstance (instanceID ,name) {
        this.$dialog
            .confirm(`Are you sure you want to delete instance "${name}" ?`)
            .then(() => {
                this.$store.dispatch('setLoadStatus')
                fetch(this.$api + 'tours/instances/' + instanceID + '/delete', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Authorization': localStorage.getItem('token')
                    }
                })
                .then(res => res.json())
                .then(response => {
                    this.errors = response.errors
                    if(response.success == true) {
                        this.$notify({
                            type: 'success',
                            title: response.message
                        });
                        this.$emit('getGroup')
                    } else if (response.errors) {
                        this.$notify({
                            type: 'error',
                            title: response.message
                        });
                } else {
                    this.$notify({
                        type: 'error',
                        title: response.Error
                    });
                }
                    this.$store.dispatch('setLoadStatus')
                });
            }).catch(() => {
                console.log('Clicked on cancel');
            });
    },
    selectAllInstances(event) {
      if (event.target.checked) {
        let instanceIDS = this.group.instances.map(instance => instance.id);
        this.selectedInstancesForFlightTimeCheck = instanceIDS;
      } else {
        this.selectedInstancesForFlightTimeCheck = []
      }
    },
    handleInstanceFlights(type) {
      if (this.selectedInstancesForFlightTimeCheck.length > 0) {
          this.flightUpdateComponent = type === 'times' ? 'InstanceFlightTimes' : 'InstanceFlightBudget'
          this.showFlightUpdateModel = true
      } else {
          this.$notify({
              type: 'warning',
              title: 'Please select at least one instance.'
          });
      }
    },
    resetForm() {
      this.newInstance = {
        currency: 'GBP',
        indirect_flights: 0,
        tour_id: this.group.tour.id,
        tour_group_id: this.group.id,
        departure_date : JSON.parse(JSON.stringify(this.group.start_date)), 
      }
    }
  }            
}
</script>

<style scoped>
.is-special {
  background: #e8e8e8;
}
</style>